import { Link, useLocation } from "react-router-dom";
import { BarChart3, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { usePowtoonAuth } from "@/lib/auth/PowtoonAuthContext";
import { Badge } from "@/components/ui/badge";

const tabClass =
  "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors";

export function AppNav() {
  const { pathname } = useLocation();
  const { isLoading, isAuthenticated } = usePowtoonAuth();
  const onAnalytics = pathname.startsWith("/trainer/analytics");
  const onAvatars = pathname.startsWith("/trainer") && !onAnalytics;

  if (isLoading || !isAuthenticated) return null;

  return (
    <nav className="flex items-center gap-1" aria-label="Main">
      <Link
        to="/trainer"
        className={cn(
          tabClass,
          onAvatars
            ? "bg-[#f2ebfc] text-[#854ce0]"
            : "text-[#696f89] hover:text-[#854ce0]",
        )}
      >
        <Users className="h-4 w-4" />
        Avatars
      </Link>

      <Link
        to="/trainer/analytics"
        className={cn(
          tabClass,
          onAnalytics
            ? "bg-[#f2ebfc] text-[#854ce0]"
            : "text-[#696f89] hover:text-[#854ce0]",
        )}
      >
        <BarChart3 className="h-4 w-4" />
        Analytics
        <Badge variant="secondary" className="ml-1 text-[10px] px-1.5 py-0">
          Demo
        </Badge>
      </Link>
    </nav>
  );
}